export function invoiceSaleDate(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const value = type => parts.find(part => part.type === type).value;
    return `${value('year')}-${value('month')}-${value('day')}`;
}

export function comparisonNeedsTariffRefresh(comparison, zone, today = invoiceSaleDate()) {
    const catalog = comparison?.result?.catalogo;
    return catalog?.source === 'neuro_hers' && (catalog.filtro?.fecha_vigencia !== today || catalog.filtro?.geo_zone !== zone);
}
